import React from 'react';
import PropTypes from 'prop-types';

import EditScreenField from './EditScreenField';

const EditScreenForm = ({ children }) => {
  return (
    <form aria-label="form">
      <div data-testid="edit-screen" className="p-5">
        {React.Children.map(children, (child, index) => {
          return (
            <div>
              {child}
              {index === children.length - 1 ? null : (
                <div className="border-t border-gray-200" />
              )}
            </div>
          );
        })}
      </div>
    </form>
  );
};

EditScreenForm.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.object
  ]).isRequired
};

EditScreenForm.EditScreenField = EditScreenField;

export default EditScreenForm;
